//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import debounce from 'lodash/debounce';
import HintEmail from '~/components/common/hintEmail';
import Phone from '~/components/common/phone';
import PrivacyPolicy from '~/components/common/privacyPolicy';
import addAnyFormFields from '~/utils/addAnyFormFields';
import urlencodeFormData from '~/utils/urlencodeFormData';
import { getGRecaptchaScore } from '@/utils/grecaptcha';
import handleError from '@/utils/handleError';
import customerIoMixin from '@/mixins/customerIo.mixin';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    HintEmail,
    Phone,
    PrivacyPolicy,
  },
  mixins: [customerIoMixin],
  data() {
    return {
      fullHeight: false,
      form: {
        loading: false,
        data: {
          name: '',
          phone: '',
          email: '',
          acceptedRules: true,
        },
      },
    };
  },
  computed: {
    isEmailAvailable() {
      return !!this.$app.user?.email;
    },
    isNameAvailable() {
      return !!this.$app.user?.name;
    },
    isPhoneAvailable() {
      return !!this.$app.user?.profile?.phone;
    },
  },
  watch: {
    '$store.state.customerIo.userDataFromCio': {
      handler(dataFromCio) {
        if (!this.$app.user?.email && dataFromCio?.email) {
          this.form.data.email = dataFromCio.email;
        }
        if (!this.$app.user?.profile?.phone && dataFromCio?.phone) {
          this.form.data.phone = dataFromCio.phone;
        }
        if (!this.$app.user?.name && dataFromCio?.name) {
          this.form.data.name = dataFromCio.name;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.resizeHandler();
    window.addEventListener('resize', debounce(this.resizeHandler, 10));
  },
  destroyed() {
    window.removeEventListener('resize', debounce(this.resizeHandler, 10));
  },
  mounted() {
    setTimeout(
      async () => await addAnyFormFields.call(this, { ref: this.$refs.form }),
      0,
    );
    const email = this.$app.user?.email;
    const name = this.$app.user?.name;
    const phone = this.$app.user?.profile?.phone;
    if (email) this.form.data.email = email.trim();
    if (name) this.form.data.name = name.trim();
    if (phone) this.form.data.phone = phone.trim();
  },
  methods: {
    async onSubmit() {
      if (this.form.loading) return;

      this.form.loading = true;
      const isValid = await this.$refs.form.validate();

      if (!isValid) {
        this.form.loading = false;
        return;
      }

      try {
        window?.$meter?.event({
          name: 'formSubmit',
          label: 'helpFormOnTheSalePage',
        });
      } catch (e) {
        console.error(e);
      }

      const formData = new FormData(this.$refs.form.$el.querySelector('form'));
      formData.append('name', this.form.data.name);
      formData.append('phone', this.form.data.phone);
      formData.append('email', this.form.data.email);
      formData.append('checkbox', this.form.data.acceptedRules);

      const grecaptchaScore = await getGRecaptchaScore.bind(this)();
      formData.append('google_score', grecaptchaScore);

      try {
        const response = await this.$axios({
          method: 'post',
          url: this.$app.config.current.feedbackUrl,
          data: urlencodeFormData(formData),
          headers: {
            'Content-Type': `application/x-www-form-urlencoded`,
          },
        });

        this.successDialog = true;

        this.$refs.form?.reset();
        if (!this.isEmailAvailable) this.form.data.email = '';
        if (!this.isNameAvailable) this.form.data.name = '';
        if (!this.isPhoneAvailable) this.form.data.phone = '';

        this.$gtm?.push({
          event: 'autoEvent',
          eventCategory: 'ds_lead',
          eventAction: 'from_form',
        });

        if (response.status === 200) {
          try {
            window?.$meter?.event({
              name: 'formSuccess',
              label: 'helpFormOnTheSalePage',
            });
          } catch (e) {
            console.error(e);
          }
        }
      } catch (e) {
        handleError.bind(this)(e);
      }

      this.form.loading = false;

      this.closeDialog();

      this.$nextTick(() => {
        this.$store.dispatch('modalNotify/OPEN', {
          title: this.$t('index.success-dialog.title'),
          description: this.$t('index.success-dialog.description'),
          action: this.$t('index.success-dialog.btn'),
        });
      });
    },
    closeDialog() {
      this.$store.commit('sale/setChoiceDialog', false);
    },
    resizeHandler() {
      this.fullHeight = window.innerHeight < 650;
    },
  },
};
